import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const AlbumFolderGalleryIcon = ({
  color = '#cdd6e3',
  size = '45',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="14" height="14" fill={color} rx="1" />
      <rect x="18" y="0" width="14" height="14" fill={color} rx="1" />
      <rect x="0" y="18" width="14" height="14" fill={color} rx="1" />
      <rect x="18" y="18" width="14" height="14" fill={color} rx="1" />
    </g>
  </svg>
);

AlbumFolderGalleryIcon.propTypes = propTypes;

export default AlbumFolderGalleryIcon;
